import { ApplicationStore } from '../states'

export const updateUserName: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    userName: payload,
  }
}

export const removeUserName: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.userName
  return {
    ...newState,
  }
}
